export const one = 1
export const ALL_VALUE = "All";
export const ALL_GRADES_VALUE = "ALL_GRADES";
